import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/common/material-module';


@Component({
    selector: 'app-confirm-email-dialog',
    imports: [MaterialModule],
    templateUrl: './confirm-email-dialog.component.html',
    styleUrl: './confirm-email-dialog.component.scss'
})
export class ConfirmEmailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { hs_email: string, admin_email: string }
  ) {}

  confirm() {
    // Pass the correct email based on the condition
    let email = this.data.hs_email;
    if (this.data.admin_email === '') email = this.data.hs_email;
    else if (this.data.hs_email === '') email = this.data.admin_email;
    else if (this.data.hs_email === this.data.admin_email) email = this.data.admin_email;
    this.dialogRef.close(email);
  }
}
